var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1673 14.6667C15.1673 14.94 14.9407 15.1667 14.6673 15.1667H1.33398C1.06065 15.1667 0.833984 14.94 0.833984 14.6667C0.833984 14.3867 1.06065 14.1667 1.33398 14.1667H14.6673C14.9407 14.1667 15.1673 14.3867 15.1673 14.6667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.0001 6.65333V14.1667H1.9668L2.00013 6.64665C2.00013 6.23999 2.1868 5.85336 2.51346 5.60002L7.18013 1.97335C7.66013 1.59335 8.34013 1.59335 8.82013 1.97335L13.4868 5.60002C13.8135 5.85336 14.0001 6.23999 14.0001 6.65333Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5H7C6.72667 5.5 6.5 5.27333 6.5 5C6.5 4.72667 6.72667 4.5 7 4.5H9C9.27333 4.5 9.5 4.72667 9.5 5C9.5 5.27333 9.27333 5.5 9 5.5Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3327 7.33334H5.66602C5.11268 7.33334 4.66602 7.78001 4.66602 8.33334V14.6667H11.3327V8.33334C11.3327 7.78001 10.886 7.33334 10.3327 7.33334ZM7.16602 11.8333C7.16602 12.1067 6.93935 12.3333 6.66602 12.3333C6.39268 12.3333 6.16602 12.1067 6.16602 11.8333V10.8333C6.16602 10.56 6.39268 10.3333 6.66602 10.3333C6.93935 10.3333 7.16602 10.56 7.16602 10.8333V11.8333Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.891a8439575f73111e49ddb42e676485.svg";
export { ForwardRef as ReactComponent };